import createBrowserApolloClient from '@sm/apollo-clients/dist/browser';
export const setApolloClient = graphQLClientConfig => {
  if (!graphQLClientConfig.graphQLUri) {
    throw new Error('GraphQL Uri not provided');
  }
  return createBrowserApolloClient({
    uri: graphQLClientConfig.graphQLUri,
    cacheHydration: {},
    pageRequestId: graphQLClientConfig.pageRequestId,
    linkOptions: {
      credentials: 'include',
      batchInterval: 30
    },
    metadata: {
      appName: graphQLClientConfig.appName,
      appVersion: graphQLClientConfig.appVersion
    },
    availableLoggedOutPaths: []
  });
};